import { ReceiptRecoveryCase } from 'src/models/transaction.models'

interface ReceiptRecoveryProvenance {
  description: string
  label: string
}

const receiptMatchDescription =
  'The Receipt Agent found a receipt that may match this transaction. Review the receipt and confirm if it’s a match.'

export const getReceiptRecoveryProvenance = (
  recoveredFrom: ReceiptRecoveryCase['recoveredFrom'],
): ReceiptRecoveryProvenance => {
  switch (recoveredFrom) {
    case 'GMAIL':
      return {
        label: 'Found through Gmail',
        description: receiptMatchDescription,
      }
    case 'ORPHANED_RECEIPT':
      return {
        label: 'Recovered from an unassigned receipt',
        description: receiptMatchDescription,
      }
    case 'GOOGLE_DRIVE':
      return {
        label: 'Found through Google Drive',
        description: receiptMatchDescription,
      }
    default:
      return {
        label: 'Recovered by Receipt Agent',
        description: receiptMatchDescription,
      }
  }
}
